import Quill from 'quill';

const Clipboard = Quill.import('modules/clipboard') as any;
const Delta = Quill.import('delta');

export class QuillPlaintextClipboard extends Clipboard {
  onPaste(range, { text }) {
    text = text.replace(/\n{3,}/g, '\n\n');

    const delta = new Delta()
      .retain(range.index)
      .delete(range.length)
      .insert(text);
    this.quill.updateContents(delta, Quill.sources.USER);
    this.quill.setSelection(
      delta.length() - range.length,
      Quill.sources.SILENT,
    );
    this.quill.scrollIntoView();
  }
}
